import React from 'react';

import MuiToggleButton from '@mui/material/ToggleButton';

export function ToggleButton(props: any): JSX.Element {
  const { ...rest } = props;

  return <MuiToggleButton {...rest} />;
}
